import type { FaireProductEntity } from "../../entity_types/product";

export const p_g2jrz3ksar: FaireProductEntity = {
  token: "p_g2jrz3ksar",
  type: "product",
  name: "Ali+Oli Bamboo Layette Knotted Gown and Beanie for Newborns",
  brandToken: "b_con6gck7",
  brandName: "Ali+Oli",
  imageUrl:
    "https://cdn.faire.com/fastly/31773b48ad308516243a9351b2af6950a3c83300a95dbf24c2aefc43f2974a97.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/69fc7104dc0c4f5340da6d0795acaac4f13b7abeac7352a9645bc95fd660ddea.jpeg",
    "https://cdn.faire.com/fastly/20ad96b9d2d61bbbd69d149c35006ebb9851cdc80c97e026ebfad81bc01c772a.jpeg",
    "https://cdn.faire.com/fastly/7f5424d6457027639fb30780adf3a2ed735ce0a56843fdcf1535c53d2b6f7913.jpeg",
    "https://cdn.faire.com/fastly/989a3b15a3f79fd5badd6256cbe29466db6f785a59a4c665a0d22972af044eec.png",
  ],
  priceDollars: 15,
  description:
    "Keep your baby cozy and stylish with our 96% Bamboo | 4% Spandex knotted gown & beanie set in our soft neutral white color.  Perfect coming-home outfit (0-3m)\n\nOur premium knotted gown and beanie set is crafted from buttery-soft, high-quality bamboo to provide your baby with the ultimate comfort.\n\nThe luxurious, breathable fabric and snug fit are soothing, making it the perfect outfit for those precious first weeks.\n\nThe self-tying knot allows for quick, easy diaper changes without the hassle of buttons or zippers, ensuring your baby stays undisturbed. Choose your favorite color for the perfect Coming Home outfit for baby!\n\nBaby gifts, Baby Clothing, Christmas, Kids Clothes, Organic Baby Clothes, Baby Pajamas, Newborn.",
  tags: [],
  msrpDollars: 29.99,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:46.272Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
